
import { apiRequest } from '../../apiCall'


export const getCustomerContactsRequest = () => apiRequest('Contact.GetContacts', { customerId: "" })
export const getCustomerCallTypesRequest = () => apiRequest('CustomerCall.GetCustomerCallTypes',{},'',true)
export const getCustomerCallsRequest = (params) => apiRequest('CustomerCall.Search', { ...params },'',true)
export const getCallReportFileRequest = (id) => apiRequest('CustomerCall.RecordUrlList', {}, "?RecordingId=" + id,true)







